import { commonConfig, CommonConfigKeys } from './common.config'
import { ConfigType } from './types'

export type DevelopmentEnvConfigKeys = CommonConfigKeys

export const developmentConfig: ConfigType = commonConfig
